const modalBase = 1040;
const sidebar = 6;
const zIndices = {
  sidebar,
  sidebarContentColumn: sidebar + 1,
  sidebarOverlay: sidebar - 1,
  modalOverlay: modalBase,
  modalBody: modalBase + 10,
  notifications: modalBase + 11,
  dropdownMenu: modalBase + 11
};
export default zIndices;
